import { Notification } from "rsuite";
import axios from "../../utilities/axios";
import { Event } from "../Event";

export class UserManagerFkUserIdEvents extends Event {
    public onChange = (value: any, setField: any, setState: any, formValues: any) => {
       
    }
}